'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AiUpload2 = function (_React$Component) {
    _inherits(AiUpload2, _React$Component);

    function AiUpload2() {
        _classCallCheck(this, AiUpload2);

        return _possibleConstructorReturn(this, (AiUpload2.__proto__ || Object.getPrototypeOf(AiUpload2)).apply(this, arguments));
    }

    _createClass(AiUpload2, [{
        key: 'svgPath',
        value: function svgPath(strokeColor, strokeWidth) {
            return _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M43.996,27.722C43.954,22.788,39.944,18.8,35,18.8c-3.997,0-7.382,2.609-8.556,6.216C25.618,24.502,24.645,24.2,23.6,24.2 c-2.982,0-5.4,2.417-5.4,5.399c0,0.291,0.029,0.573,0.074,0.85C15.74,31.738,14,34.363,14,37.4c0,4.308,3.493,7.8,7.8,7.8h5.991 v-6.6H24.2l7.8-9l7.8,9h-3.609v6.6H41c4.97,0,9-4.029,9-9C50,32.282,47.491,28.958,43.996,27.722z' })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var strokeColor = this.props.strokeColor || 'white';
            var strokeWidth = this.props.strokeWidth || 0;
            var viewBox = '0 0 64 64';
            var style = {
                fontSize: '200%',
                verticalAlign: '-23%'
            };

            if (this.props.noPad) {
                viewBox = '14 14 36 36';
                style = {};
            }

            var props = _underscore2.default.omit(this.props, 'noPad', 'strokeColor');

            if (this.props.strokeWidth > 0) {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-upload-2', viewBox: viewBox, style: style }, props),
                    this.svgPath(strokeColor, strokeWidth),
                    this.svgPath('white', 0)
                );
            } else {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-upload-2', viewBox: viewBox, style: style }, props),
                    this.svgPath('white', 0)
                );
            }
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return Object.assign({}, _reactIconBase2.default.propTypes, {
                strokeColor: _propTypes2.default.string,
                strokeWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
                noPad: _propTypes2.default.bool
            });
        }
    }]);

    return AiUpload2;
}(_react2.default.Component);

exports.default = AiUpload2;